import { c as _c } from "react/compiler-runtime";
import { Shimmer } from '@onefootprint/ui';
const Loading = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <Shimmer height="150px" width="100%" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
export default Loading;